import React, { useState } from "react";
import logo from "../../assets/Admin/newlogo.png";
import { useNavigate } from "react-router-dom";
import { CgMenuLeft } from "react-icons/cg";
import { FaHome, FaLayerGroup, FaThList, FaTable } from "react-icons/fa";
import { GrTransaction, GrFormView } from "react-icons/gr";
import { IoMdArrowDropdown, IoMdAdd } from "react-icons/io";
import { FaUsers } from "react-icons/fa";
import { GrUserAdmin } from "react-icons/gr";
import { TbTruckDelivery } from "react-icons/tb";
import { TbTruckOff } from "react-icons/tb";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoPeopleCircleSharp } from "react-icons/io5";
import { getHeaderMenusAPI, getReferralAgetsDetails } from "../../serverApi/server"
import { HiMiniPencilSquare } from "react-icons/hi2";
import { IoCloudUploadSharp } from "react-icons/io5";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RiDeleteBin2Fill } from "react-icons/ri";
import { FaWpforms } from "react-icons/fa6";
import { GiMartyrMemorial } from "react-icons/gi";
import { SiGooglemarketingplatform } from "react-icons/si";
import { MdDesignServices } from "react-icons/md";
import { FaTruck } from 'react-icons/fa';
import { FaBoxOpen } from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';
import { VscReferences } from "react-icons/vsc";
import { MdOutlineCreate } from "react-icons/md";
import { PiUsersThreeFill } from "react-icons/pi";
import { IoHeartDislikeCircle } from "react-icons/io5";
import { RiWifiOffLine } from "react-icons/ri";
import { HiStatusOffline } from "react-icons/hi";
import { TbTransactionDollar } from "react-icons/tb";
import { RiUserSearchLine } from "react-icons/ri";
import { FaRocketchat } from "react-icons/fa6";


const SideBar = () => {
  const [activeSideBar, setActiveSideBar] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();

  const toggleSideBar = () => {
    setActiveSideBar((prevState) => !prevState);
  }

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const subCategoriesPrice = async() => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/sub-category-pricing', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }

  const fieldPricing = async() => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/field-pricing', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }

  const subscribers = () => {
    navigate('/admin/subscribers');
  }

  const transaction = () => {
    navigate('/admin/transaction');
  }

  const OfflineTransaction = () => {
    navigate('/admin/offline_transaction');
  }

  const dashboard = async() => {
    navigate('/admin/dashboard')
  }
  const userData = async() => {
    navigate('/admin/users_data')
  }
  const adminData = async() => {
    navigate('/admin/admin_data')
  }

  const currentOrders = async() => {
    navigate('/admin/current_orders')
  }
  const dispatchOrders = async() => {
    navigate('/admin/dispatched_orders')
  }
  const prdouctDescription = async() => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/productdescription', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }
  const headerDescription = async() => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/headerdescription', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }
  const uploadDesignAssets = async() => {
    navigate('/admin/upload_designassets')
  }

  const zipFileUpload = async() => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/category_image_upload', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }

  const CategoryImagesDeleteUpdate = async() => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/category_images_delete_update', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }

  const sendClientMail = async() => {
    navigate('/admin/send_client_mail')
  }

  const categoryKeywords= async() => { 
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/category_keywords',{state: getHeaderMenusAPIResponse.header_menus_serializer})
  }

  const FieldDescription = async () => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/field_description', { state: getHeaderMenusAPIResponse.header_menus_serializer })
  }

  const creareReferralAgents = async () => {
    navigate('/admin/create_referral_agent')
  }

  const viewReferralUsers = async () => {
    const getReferralAgetsDetailsResponse = await getReferralAgetsDetails()
    navigate('/admin/view_referral_users', {state: getReferralAgetsDetailsResponse.data.referral_user_details_serializer})
  }

  const viewAllReferralAgents = async () => {
    navigate('/admin/view_all_referral_agents')
  }

  const youMayAlsoLike = async () => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/you_may_like', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }

  const placeOfflineOrder = async () => {
    const getHeaderMenusAPIResponse = await getHeaderMenusAPI()
    navigate('/admin/offline_order_images', {state: getHeaderMenusAPIResponse.header_menus_serializer})
  }

  const offlineOrders = () => {
    navigate('/admin/offline_orders')
  }

  const searchUserList = () => {
    navigate('/admin/search_user_details')
  }

  return (

    <section
        className={`relative h-[100%] bg-[#1A2035] duration-200 shrink-0 ${ activeSideBar
            ? "w-64 opacity-100"
            : "w-16 opacity-100"
        }`}
      >
      <div className="mb-6 px-5 py-5 flex items-center justify-between">
        { activeSideBar && (
          <div>
            <img src={logo} alt="logo" className="w-36" />
          </div>
        ) }
          { activeSideBar ? (<CgMenuLeft className="rotate-180 text-2xl hover:bg-neutral-600 rounded-full text-white cursor-pointer" onClick={toggleSideBar}/>) : (<BsThreeDotsVertical className="text-2xl hover:bg-neutral-600 rounded-full text-white cursor-pointer" onClick={toggleSideBar}/>) }
      </div>

      <ul className="text-neutral-400 bg-[#1A2035]" style={{height: '0% !important'}}>
        <li onClick={dashboard} className="cursor-pointer">
          <div className="group px-6 py-3 mb-4 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <FaHome className="group-focus:text-[#6861CE] text-base" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Dashboard
              </h2>
            )}
          </div>
        </li>

        <li onClick={() => toggleDropdown(null)} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <FaLayerGroup className="group-focus:text-[#6861CE] text-base" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Images
              </h2>
            )}
          </div>
        </li>

        <li onClick={() => toggleDropdown(0)}>
          <div
            className={`group px-6 py-2 cursor-pointer ${
              activeDropdown === 0
                ? "mb-0 bg-[#151a2b] border-l-2 border-[#6861CE]"
                : "mb-1"
            } duration-300 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center justify-between gap-5`}
          >
            <div className="flex items-center gap-5">
              <FaThList className="group-focus:text-[#6861CE] text-[15px]" />
              { activeSideBar && (
                <h2 className="font-medium group-focus:text-white text-[15px]">
                  Pricing
                </h2>
              )}
            </div>
            <IoMdArrowDropdown
              className={`${
                activeDropdown === 0 ? "rotate-180" : "rotate-0"
              } duration-200`}
            />
          </div>
          { activeSideBar && (
            <ul
              className={`bg-[#151a2b] text-neutral-300 transition-all duration-300 overflow-hidden ${
                activeDropdown === 0
                  ? "max-h-40 opacity-100 px-6 pt-4 pb-3"
                  : "max-h-0 opacity-0"
              }`}
            >
              <li className="mb-3 flex items-center gap-3 cursor-pointer" onClick={subCategoriesPrice}>
                <IoMdAdd />
                <h3>Add Categories</h3>
              </li>
              <li className="flex items-center gap-3 cursor-pointer" onClick={fieldPricing}>
                <GrFormView />
                <h3>Field Pricing</h3>
              </li>
            </ul>
          )}
        </li>

        <li onClick={() => toggleDropdown(1)}>
          <div
            className={`group px-6 py-2 cursor-pointer ${
              activeDropdown === 1
                ? "mb-0 bg-[#151a2b] border-l-2 border-[#6861CE]"
                : "mb-1"
            } duration-300 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center justify-between gap-5`}
          >
            <div className="flex items-center gap-5">
              <FaTable className="group-focus:text-[#6861CE] text-[15px]" />
              { activeSideBar && (
                <h2 className="font-medium group-focus:text-white text-[15px]">
                  Users
                </h2>
              )}
            </div>
            <IoMdArrowDropdown
              className={`${
                activeDropdown === 1 ? "rotate-180" : "rotate-0"
              } duration-200`}
            />
          </div>
          { activeSideBar && (
            <ul
              className={`bg-[#151a2b] text-neutral-300 transition-all duration-300 overflow-hidden ${
                activeDropdown === 1
                  ? "max-h-40 opacity-100 px-6 pt-4 pb-3"
                  : "max-h-0 opacity-0"
              }`}
            >
              <li onClick={userData} className="mb-3 flex items-center gap-3 cursor-pointer">
                <FaUsers />
                <h3>Users Data</h3>
              </li>
              <li onClick={adminData} className="flex items-center gap-3 cursor-pointer">
                <GrUserAdmin />
                <h3>Admin Data</h3>
              </li>
            </ul>
          )}
        </li>

        <li onClick={() => toggleDropdown(2)}>
          <div
            className={`group px-6 py-2 cursor-pointer ${
              activeDropdown === 2
                ? "mb-0 bg-[#151a2b] border-l-2 border-[#6861CE]"
                : "mb-1"
            } duration-300 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center justify-between gap-5`}
          >
            <div className="flex items-center gap-5">
              <FaTable className="group-focus:text-[#6861CE] text-[15px]" />
              { activeSideBar && (
                <h2 className="font-medium group-focus:text-white text-[15px]">
                  Orders
                </h2>
              )}
            </div>
            <IoMdArrowDropdown
              className={`${
                activeDropdown === 2 ? "rotate-180" : "rotate-0"
              } duration-200`}
            />
          </div>
          { activeSideBar && (
            <ul
              className={`bg-[#151a2b] text-neutral-300 transition-all duration-300 overflow-hidden ${
                activeDropdown === 2
                  ? "max-h-40 opacity-100 px-6 pt-4 pb-3"
                  : "max-h-0 opacity-0"
              }`}
            >
              <li onClick={currentOrders} className="mb-3 flex items-center gap-3 cursor-pointer">
                <TbTruckDelivery />
                <h3>Current Orders</h3>
              </li>
              <li onClick={dispatchOrders} className="mb-3 flex items-center gap-3 cursor-pointer">
                <TbTruckOff />
                <h3>Dispatched Orders</h3>
              </li>
              <li onClick={offlineOrders} className="flex items-center gap-3 cursor-pointer">
                <HiStatusOffline />
                <h3>Offline Orders</h3>
              </li>
            </ul>
          )}
        </li>

        <li onClick={() => toggleDropdown(5)}>
          <div
            className={`group px-6 py-2 cursor-pointer ${
              activeDropdown === 5
                ? "mb-0 bg-[#151a2b] border-l-2 border-[#6861CE]"
                : "mb-1"
            } duration-300 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center justify-between gap-5`}
          >
            <div className="flex items-center gap-5">
              <VscReferences className="group-focus:text-[#6861CE] text-[15px]" />
              { activeSideBar && (
                <h2 className="font-medium group-focus:text-white text-[15px]">
                  Referral
                </h2>
              )}
            </div>
            <IoMdArrowDropdown
              className={`${
                activeDropdown === 5 ? "rotate-180" : "rotate-0"
              } duration-200`}
            />
          </div>
          { activeSideBar && (
            <ul
              className={`bg-[#151a2b] text-neutral-300 transition-all duration-300 overflow-hidden ${
                activeDropdown === 5
                  ? "max-h-40 opacity-100 px-6 pt-4 pb-3"
                  : "max-h-0 opacity-0"
              }`}
            >
              <li onClick={creareReferralAgents} className="mb-3 flex items-center gap-3 cursor-pointer">
                <MdOutlineCreate />
                <h3>Create Referral</h3>
              </li>
              <li onClick={viewReferralUsers} className="mb-3 flex items-center gap-3 cursor-pointer">
                <FaUsers />
                <h3>View Referral User</h3>
              </li>
              <li onClick={viewAllReferralAgents} className="flex items-center gap-3 cursor-pointer">
                <PiUsersThreeFill />
                <h3>View All Agents</h3>
              </li>
            </ul>
          )}
        </li>
        
        <li onClick={headerDescription} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <HiMiniPencilSquare className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Header Description
              </h2>
            )}
          </div>
        </li>
        <li onClick={prdouctDescription} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <HiMiniPencilSquare className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Product Description
              </h2>
            )}
          </div>
        </li>
        <li onClick={zipFileUpload} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <IoCloudUploadOutline className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Category Image Upload
              </h2>
            )}
          </div>
        </li>
        <li onClick={CategoryImagesDeleteUpdate} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <RiDeleteBin2Fill className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Category Images Delete Update
              </h2>
            )}
          </div>
        </li>
        <li onClick={uploadDesignAssets} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <IoCloudUploadSharp className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Upload Design Assets
              </h2>
            )}
          </div>
        </li>
        




        <li onClick={() => toggleDropdown(6)}>
          <div
            className={`group px-6 py-2 cursor-pointer ${
              activeDropdown === 6
                ? "mb-0 bg-[#151a2b] border-l-2 border-[#6861CE]"
                : "mb-1"
            } duration-300 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center justify-between gap-5`}
          >
            <div className="flex items-center gap-5">
              <FaTable className="group-focus:text-[#6861CE] text-[15px]" />
              { activeSideBar && (
                <h2 className="font-medium group-focus:text-white text-[15px]">
                  Transactions
                </h2>
              )}
            </div>
            <IoMdArrowDropdown
              className={`${
                activeDropdown === 6 ? "rotate-180" : "rotate-0"
              } duration-200`}
            />
          </div>
          { activeSideBar && (
            <ul
              className={`bg-[#151a2b] text-neutral-300 transition-all duration-300 overflow-hidden ${
                activeDropdown === 6
                  ? "max-h-40 opacity-100 px-6 pt-4 pb-3"
                  : "max-h-0 opacity-0"
              }`}
            >
              <li onClick={transaction} className="mb-3 flex items-center gap-3 cursor-pointer">
                <GrTransaction />
                <h3>Online Transactions</h3>
              </li>
              <li onClick={OfflineTransaction} className="mb-3 flex items-center gap-3 cursor-pointer">
                <TbTransactionDollar />
                <h3>Offline Transactions</h3>
              </li>
            </ul>
          )}
        </li>



        {/* <li onClick={transaction} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <GrTransaction className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Transactions
              </h2>
            )}
          </div>
        </li> */}




        <li onClick={subscribers} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <IoPeopleCircleSharp className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Subscribers
              </h2>
            )}
          </div>
        </li>
        <li onClick={sendClientMail} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <IoPeopleCircleSharp className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Send Client Mail
              </h2>
            )}
          </div>
        </li>
        <li onClick={categoryKeywords} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <HiMiniPencilSquare  className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Category Keywords
              </h2>
            )}
          </div>
        </li>
        <li onClick={FieldDescription} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <HiMiniPencilSquare className="group-focus:text-[#6861CE] text-[15px]" />
            {activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Field Description
              </h2>
            )}
          </div>
        </li>
        <li onClick={youMayAlsoLike} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <IoHeartDislikeCircle className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                You May Like
              </h2>
            )}
          </div>
        </li>

        <li onClick={placeOfflineOrder} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <RiWifiOffLine className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Place Offline Order
              </h2>
            )}
          </div>
        </li>


        <li onClick={()=>navigate('/admin/search_user_details')} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <RiUserSearchLine className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Search User List
              </h2>
            )}
          </div>
        </li>


        <li onClick={()=>navigate('/admin/admin-chat')} className="cursor-pointer">
          <div className="group px-6 py-2 mb-1 hover:bg-[#151a2b] active:bg-[#151a2b] focus:bg-[#151a2b] focus:border-l-2 focus:border-[#6861CE] duration flex items-center gap-5">
            <FaRocketchat className="group-focus:text-[#6861CE] text-[15px]" />
            { activeSideBar && (
              <h2 className="font-medium group-focus:text-white text-[15px]">
                Admin Live Chat
              </h2>
            )}
          </div>
        </li>


        

      </ul>
    </section>
  )
}

export default SideBar
